import React from 'react';
import AppRoutes from './app/AppRoutes';
import { TranslationProvider } from './hooks/useTranslation';
import { AuthProvider } from './hooks/useAuth';

function App() {
  return (
    <TranslationProvider>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </TranslationProvider>
  );
}

export default App;